import { ALL_PURCHASE_FAIL, ALL_PURCHASE_POST_FAIL, ALL_PURCHASE_POST_REQUEST, ALL_PURCHASE_POST_SUCCESS, ALL_PURCHASE_REQUEST, ALL_PURCHASE_SUCCESS, CLEAR_ERRORS, GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_FAIL, GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_ON_DATE_FAIL, GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_ON_DATE_REQUEST, GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_ON_DATE_SUCCESS, GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_REQUEST, GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_SUCCESS, GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_FAIL, GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_FAIL, GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_REQUEST, GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_SUCCESS, GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_REQUEST, GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_SUCCESS, GET_PURCHASE_CREDIT_FAIL, GET_PURCHASE_CREDIT_ON_SHOP_FAIL, GET_PURCHASE_CREDIT_ON_SHOP_REQUEST, GET_PURCHASE_CREDIT_ON_SHOP_SUCCESS, GET_PURCHASE_CREDIT_REQUEST, GET_PURCHASE_CREDIT_SINGLE_RECORD_FAIL, GET_PURCHASE_CREDIT_SINGLE_RECORD_REQUEST, GET_PURCHASE_CREDIT_SINGLE_RECORD_SUCCESS, GET_PURCHASE_CREDIT_SUCCESS, UPDATE_PURCHASE_CREDIT_FAIL, UPDATE_PURCHASE_CREDIT_REQUEST, UPDATE_PURCHASE_CREDIT_SUCCESS } from "../constants/puchaseConstants";

export const postPurchaseReducer = (state = { purchasePost: []}, action)=>{
    switch (action.type){
        case ALL_PURCHASE_POST_REQUEST:
            return{
                purchasePostLoading: true,
                purchasePost: [],
            };
        case ALL_PURCHASE_POST_SUCCESS: 
            return {
                purchasePostLoading: false,
                purchasePost: action.payload
            }
        case ALL_PURCHASE_POST_FAIL:
            return {
                purchasePostLoading: false,
                purchasePostError: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                purchasePostError: null,
            }
            default:
            return state;
            
    }
}


export const getPurchaseReducer = (state = { purchaseRecord: []}, action)=>{
    switch (action.type){
        case ALL_PURCHASE_REQUEST:
            return{
                loading: true,
                purchaseRecord: [],
            };
        case ALL_PURCHASE_SUCCESS: 
            return {
                loading: false,
                purchaseRecord: action.payload
            }
        case ALL_PURCHASE_FAIL:
            return {
                loading: false,
                error: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            }
            default:
            return state;
            
    }
}

export const getPurchaseConsolidatedForShopsReducer = (state = { purchaseConsolidateForShopsRecord: []}, action)=>{
    switch (action.type){
        case GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_REQUEST:
            return{
                purchaseConsolidateForShopsRecordLoading: true,
                purchaseConsolidateForShopsRecord: [],
            };
        case GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_SUCCESS: 
            return {
                purchaseConsolidateForShopsRecordLoading: false,
                purchaseConsolidateForShopsRecord: action.payload
            }
        case GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_FAIL:
            return {
                purchaseConsolidateForShopsRecordLoading: false,
                purchaseConsolidateForShopsRecordError: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                purchaseConsolidateForShopsRecordError: null,
            }
            default:
            return state;
            
    }
}

export const getPurchaseConsolidatedForSpecificShopsReducer = (state = { purchaseConsolidateForSpecificShopsRecord: []}, action)=>{
    switch (action.type){
        case GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_REQUEST:
            return{
                purchaseConsolidateForSpecificShopsRecordLoading: true,
                purchaseConsolidateForSpecificShopsRecord: [],
            };
        case GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_SUCCESS: 
            return {
                purchaseConsolidateForSpecificShopsRecordLoading: false,
                purchaseConsolidateForSpecificShopsRecord: action.payload
            }
        case GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_FAIL:
            return {
                purchaseConsolidateForSpecificShopsRecordLoading: false,
                purchaseConsolidateForSpecificShopsRecordError: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                purchaseConsolidateForSpecificShopsRecordError: null,
            }
            default:
            return state;
            
    }
}


export const getPurchaseConsolidatedForShopsOnDateReducer = (state = { purchaseConsolidateForShopsOnDateRecord: []}, action)=>{
    switch (action.type){
        case GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_ON_DATE_REQUEST:
            return{
                purchaseConsolidateForShopsOnDateRecordLoading: true,
                purchaseConsolidateForShopsOnDateRecord: [],
            };
        case GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_ON_DATE_SUCCESS: 
            return {
                purchaseConsolidateForShopsOnDateRecordLoading: false,
                purchaseConsolidateForShopsOnDateRecord: action.payload
            }
        case GET_PURCHASE_CONSOLIDATED_FOR_SHOPS_ON_DATE_FAIL:
            return {
                purchaseConsolidateForShopsOnDateRecordLoading: false,
                purchaseConsolidateForShopsOnDateRecordError: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                purchaseConsolidateForShopsOnDateRecordError: null,
            }
            default:
            return state;
            
    }
}

export const getPurchaseConsolidatedForSpecificShopsOnDateReducer = (state = { purchaseConsolidateForSpecificShopsOnDateRecord: []}, action)=>{
    switch (action.type){
        case GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_REQUEST:
            return{
                purchaseConsolidateForSpecificShopsOnDateRecordLoading: true,
                purchaseConsolidateForSpecificShopsOnDateRecord: [],
            };
        case GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_SUCCESS: 
            return {
                purchaseConsolidateForSpecificShopsOnDateRecordLoading: false,
                purchaseConsolidateForSpecificShopsOnDateRecord: action.payload
            }
        case GET_PURCHASE_CONSOLIDATED_FOR_SPECIFIC_SHOP_ON_DATE_FAIL:
            return {
                purchaseConsolidateForSpecificShopsOnDateRecordLoading: false,
                purchaseConsolidateForSpecificShopsOnDateRecordError: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                purchaseConsolidateForSpecificShopsOnDateRecordError: null,
            }
            default:
            return state;
            
    }
}


export const getSinglePurchaseCreditReducer = (state = { singlePurchaseCreditRecord: []}, action)=>{
    switch (action.type){
        case GET_PURCHASE_CREDIT_SINGLE_RECORD_REQUEST:
            return{
                singlePurchaseCreditRecordLoading: true,
                singlePurchaseCreditRecord: [],
            };
        case GET_PURCHASE_CREDIT_SINGLE_RECORD_SUCCESS: 
            return {
                singlePurchaseCreditRecordLoading: false,
                singlePurchaseCreditRecord: action.payload,
                // newPurchasesProduct: action?.payload?.newPurchasesProduct
            }
        case GET_PURCHASE_CREDIT_SINGLE_RECORD_FAIL:
            return {
                singlePurchaseCreditRecordLoading: false,
                singlePurchaseCreditRecordError: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                singlePurchaseCreditRecordError: null,
            }
            default:
            return state;
            
    }
}

export const getPurchaseCreditReducer = (state = { purchaseCreditRecord: []}, action)=>{
    switch (action.type){
        case GET_PURCHASE_CREDIT_REQUEST:
            return{
                purchaseCreditRecordLoading: true,
                purchaseCreditRecord: [],
            };
        case GET_PURCHASE_CREDIT_SUCCESS: 
            return {
                purchaseCreditRecordLoading: false,
                purchaseCreditRecord: action.payload,
                // newPurchasesProduct: action?.payload?.newPurchasesProduct
            }
        case GET_PURCHASE_CREDIT_FAIL:
            return {
                purchaseCreditRecordLoading: false,
                purchaseCreditRecordError: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                purchaseCreditRecordError: null,
            }
            default:
            return state;
            
    }
}


export const getPurchaseCreditOnShopReducer = (state = { purchaseCreditOnShopRecord: []}, action)=>{
    switch (action.type){
        case GET_PURCHASE_CREDIT_ON_SHOP_REQUEST:
            return{
                purchaseCreditOnShopRecordLoading: true,
                purchaseCreditOnShopRecord: [],
            };
        case GET_PURCHASE_CREDIT_ON_SHOP_SUCCESS: 
            return {
                purchaseCreditOnShopRecordLoading: false,
                purchaseCreditOnShopRecord: action.payload,
                // newPurchasesProduct: action?.payload?.newPurchasesProduct
            }
        case GET_PURCHASE_CREDIT_ON_SHOP_FAIL:
            return {
                purchaseCreditOnShopRecordLoading: false,
                purchaseCreditOnShopRecordError: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                purchaseCreditOnShopRecordError: null,
            }
            default:
            return state;
            
    }
}


export const updatePurchaseCreditOnShopReducer = (state = { updatePurchaseCreditRecord: []}, action)=>{
    switch (action.type){
        case UPDATE_PURCHASE_CREDIT_REQUEST:
            return{
                updatePurchaseCreditRecordLoading: true,
                updatePurchaseCreditRecord: [],
            };
        case UPDATE_PURCHASE_CREDIT_SUCCESS: 
            return {
                updatePurchaseCreditRecordLoading: false,
                updatePurchaseCreditRecord: action.payload,
                // newPurchasesProduct: action?.payload?.newPurchasesProduct
            }
        case UPDATE_PURCHASE_CREDIT_FAIL:
            return {
                updatePurchaseCreditRecordLoading: false,
                updatePurchaseCreditRecordError: action.payload,
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                updatePurchaseCreditRecordError: null,
            }
            default:
            return state;
            
    }
}
